import React from "react";
import { FooterContent } from "./Footer.style";

export default class Footer extends React.Component {
  render() {
    return (
      <FooterContent>
        <span className="footer-item" style={{ fontSize: 14 }}>
          © Copyright Human Capital
        </span>

        <span style={{ fontSize: 14 }} className="contact-us-msg">
          Contact us at members@human.capital
        </span>

        <div className="footer-item" style={{ fontSize: 12, color: "white" }}>
          <span
            style={{
              borderRight: "1px solid white",
              paddingRight: "20px",
              textDecoration: "underline",
            }}
          >
            <a href="/terms" target="_blank" style={{ color: "inherit" }}>
              Terms Of Service
            </a>
          </span>

          <span
            style={{
              borderLeft: "1px solid white",
              paddingLeft: "20px",
              textDecoration: "underline",
            }}
          >
            <a href="/privacy" target="_blank" style={{ color: "inherit" }}>
              Privacy Policy
            </a>
          </span>
        </div>
      </FooterContent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js